import MapOnDemandClientTemplate from './MapOnDemandClientTemplate';

export default MapOnDemandClientTemplate;
